import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';

const messages = defineMessages({
  Yes: 'Yes',
  No: 'No',
});

const YesNoSingleSelect = ({ value = null, onChange, placeholder = null, intl }) => {
  return (
    <select
      className={`form-control ${value === null ? 'placeholder-selected' : ''}`}
      value={value === null ? '' : value.toString()}
      onChange={e => {
        const selectedValue = e.target.value;
        onChange(selectedValue === '' ? null : [selectedValue === 'true']);
      }}
    >
      <option value="" style={{ color: '#6c757d' }}>
        {placeholder}
      </option>
      <option value="true">
        {intl.formatMessage(messages.Yes)} - {placeholder}
      </option>
      <option value="false">
        {intl.formatMessage(messages.No)} - {placeholder}
      </option>
    </select>
  );
};

YesNoSingleSelect.propTypes = {
  value: PropTypes.oneOfType([PropTypes.array, PropTypes.oneOf([null])]),
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  intl: intlShape.isRequired,
};

export default injectIntl(YesNoSingleSelect);
